import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import FullWidthContainer from 'components/consumer/FullWidthContainer';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import ManualInputSlider from './components/ManualInputSlider';
import CustomerPhotosSlider from './components/CustomerPhotosSlider';
import CardCarousel from './components/CardCarousel';
import EmblaCarousel from './components/EmblaCarousel';
const ImageSliderStandard = props => {
  const $ = _c(68);
  const {
    arrowPosition: t0,
    disableSliding: t1,
    fabricGridControls: t2,
    fullWidth,
    hideArrowsIfAllSlidesVisible: t3,
    isMobileMaterialSwatches: t4,
    variant
  } = props;
  const arrowPosition = t0 === undefined ? "standard" : t0;
  const disableSliding = t1 === undefined ? false : t1;
  const fabricGridControls = t2 === undefined ? false : t2;
  const hideArrowsIfAllSlidesVisible = t3 === undefined ? false : t3;
  const isMobileMaterialSwatches = t4 === undefined ? false : t4;
  const {
    imageArray,
    imgArray,
    variation,
    children
  } = props.config;
  const finalImageArray = imgArray || imageArray || null;
  const [currentImgSet, setImageSet] = useState(0);
  let t5;
  if ($[0] !== currentImgSet || $[1] !== finalImageArray) {
    t5 = () => {
      if (!finalImageArray) {
        return null;
      }
      if (finalImageArray.length > 50 && currentImgSet === 0) {
        return finalImageArray.slice(0, 50);
      }
      return [...finalImageArray];
    };
    $[0] = currentImgSet;
    $[1] = finalImageArray;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const [finalImageDisplay, updateImageDisplay] = useState(t5);
  const [slideIndex, setSlideIndex] = useState(0);
  let visibleSlides = props.config.visibleSlides || 1;
  let navType = props.config.navType || "Button";
  let logo = props.config.logo || "";
  let title = props.config.title || "";
  let description = props.config.description || "";
  let imageWidth = 340;
  let imageHeight = 400;
  let infinite = false;
  let deviceOverride = false;
  let beforeSlideFn = null;
  let afterSlideFn = null;
  let fullHeight = false;
  let t6;
  let t7;
  if ($[3] !== currentImgSet || $[4] !== finalImageArray || $[5] !== finalImageDisplay) {
    t6 = () => {
      if (!currentImgSet || finalImageDisplay.length < 50 || !finalImageArray) {
        return;
      }
      if (currentImgSet > 0 && finalImageDisplay.length >= 50 && finalImageArray && finalImageArray.length > finalImageDisplay.length * (currentImgSet + 1) && finalImageArray.length > finalImageDisplay.length) {
        const newlength = finalImageDisplay.length * (currentImgSet + 1);
        updateImageDisplay(finalImageDisplay.concat(finalImageArray.slice(finalImageDisplay.length, newlength)));
      } else {
        if (currentImgSet > 0 && finalImageDisplay.length >= 50 && finalImageArray && finalImageArray.length < finalImageDisplay.length * (currentImgSet + 1) && finalImageArray.length > finalImageDisplay.length) {
          updateImageDisplay(finalImageDisplay.concat(finalImageArray.slice(finalImageDisplay.length)));
        }
      }
    };
    t7 = [currentImgSet, finalImageArray, finalImageDisplay];
    $[3] = currentImgSet;
    $[4] = finalImageArray;
    $[5] = finalImageDisplay;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  if ($[8] !== currentImgSet) {
    t8 = updatedSlideIndex => {
      setImageSet(currentImgSet + 1);
      setSlideIndex(updatedSlideIndex);
    };
    $[8] = currentImgSet;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const updateImageArraySize = t8;
  if (props.config.sliderConfig) {
    const {
      sliderConfig
    } = props.config;
    visibleSlides = sliderConfig.visibleSlides;
    navType = sliderConfig.navType;
    logo = sliderConfig.logo;
    title = sliderConfig.title;
    description = sliderConfig.description;
    imageWidth = sliderConfig.imageWidth;
    imageHeight = sliderConfig.imageHeight;
    infinite = sliderConfig.infinite || false;
    deviceOverride = sliderConfig.deviceOverride || false;
    beforeSlideFn = sliderConfig.beforeSlideFn;
    afterSlideFn = sliderConfig.afterSlideFn;
    fullHeight = sliderConfig.fullHeight;
  }
  if (!finalImageArray && !children) {
    return null;
  }
  const ImageSliderContainer = fullWidth ? FullWidthContainer : FixedWidthContainer;
  const t9 = arrowPosition === "standard";
  const t10 = arrowPosition === "inset";
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = classNames("ImageSliderStandard__container", {
      "[&_.slider-control-centerleft]:!left-[3px] [&_.slider-control-centerright]:!right-[3px]": t9,
      "[&_.slider-control-centerleft]:!left-8 [&_.slider-control-centerright]:!right-8": t10
    });
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== finalImageDisplay || $[14] !== hideArrowsIfAllSlidesVisible || $[15] !== imageHeight || $[16] !== imageWidth || $[17] !== infinite || $[18] !== navType || $[19] !== slideIndex || $[20] !== updateImageArraySize || $[21] !== variant || $[22] !== variation || $[23] !== visibleSlides) {
    t12 = !variation || variation.value === "Manual" ? <ManualInputSlider hideArrowsIfAllSlidesVisible={hideArrowsIfAllSlidesVisible} imageArray={finalImageDisplay} imageHeight={imageHeight} imageWidth={imageWidth} infinite={infinite} navType={navType} slideIndex={slideIndex} updateImageArraySize={updateImageArraySize} visibleSlides={visibleSlides} variant={variant} /> : null;
    $[13] = finalImageDisplay;
    $[14] = hideArrowsIfAllSlidesVisible;
    $[15] = imageHeight;
    $[16] = imageWidth;
    $[17] = infinite;
    $[18] = navType;
    $[19] = slideIndex;
    $[20] = updateImageArraySize;
    $[21] = variant;
    $[22] = variation;
    $[23] = visibleSlides;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== description || $[26] !== finalImageArray || $[27] !== imageHeight || $[28] !== imageWidth || $[29] !== logo || $[30] !== navType || $[31] !== slideIndex || $[32] !== title || $[33] !== updateImageArraySize || $[34] !== variant || $[35] !== variation || $[36] !== visibleSlides) {
    t13 = variation && variation.value === "Customer Photos" ? <CustomerPhotosSlider imageArray={finalImageArray} type={"" || "General"} logo={logo} description={description} title={title} visibleSlides={visibleSlides} imageWidth={imageWidth} imageHeight={imageHeight} navType={navType} updateImageArraySize={updateImageArraySize} slideIndex={slideIndex} variant={variant} /> : null;
    $[25] = description;
    $[26] = finalImageArray;
    $[27] = imageHeight;
    $[28] = imageWidth;
    $[29] = logo;
    $[30] = navType;
    $[31] = slideIndex;
    $[32] = title;
    $[33] = updateImageArraySize;
    $[34] = variant;
    $[35] = variation;
    $[36] = visibleSlides;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== afterSlideFn || $[39] !== beforeSlideFn || $[40] !== children || $[41] !== deviceOverride || $[42] !== disableSliding || $[43] !== fabricGridControls || $[44] !== fullHeight || $[45] !== imageHeight || $[46] !== imageWidth || $[47] !== isMobileMaterialSwatches || $[48] !== navType || $[49] !== props.config.sliderConfig || $[50] !== variant || $[51] !== variation || $[52] !== visibleSlides) {
    t14 = !isNewConsumerApp && variation && variation.value === "Component" && children ? <CardCarousel visibleSlides={visibleSlides} imageWidth={imageWidth || 400} imageHeight={imageHeight || 400} navType={navType} deviceOverride={deviceOverride} afterSlideFn={afterSlideFn} beforeSlideFn={beforeSlideFn} fabricGridControls={fabricGridControls} isMobileMaterialSwatches={isMobileMaterialSwatches} disableSliding={disableSliding} slideIndex={props.config.sliderConfig.sliderIndex} variant={variant} fullHeight={fullHeight}>{children}</CardCarousel> : null;
    $[38] = afterSlideFn;
    $[39] = beforeSlideFn;
    $[40] = children;
    $[41] = deviceOverride;
    $[42] = disableSliding;
    $[43] = fabricGridControls;
    $[44] = fullHeight;
    $[45] = imageHeight;
    $[46] = imageWidth;
    $[47] = isMobileMaterialSwatches;
    $[48] = navType;
    $[49] = props.config.sliderConfig;
    $[50] = variant;
    $[51] = variation;
    $[52] = visibleSlides;
    $[53] = t14;
  } else {
    t14 = $[53];
  }
  let t15;
  if ($[54] !== afterSlideFn || $[55] !== children || $[56] !== variant || $[57] !== variation) {
    t15 = isNewConsumerApp && variation && variation.value === "Component" && children ? <EmblaCarousel carouselConfig={{
      loop: true,
      align: "center"
    }} variant={variant} slideIndexFn={afterSlideFn}>{children}</EmblaCarousel> : null;
    $[54] = afterSlideFn;
    $[55] = children;
    $[56] = variant;
    $[57] = variation;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  let t16;
  if ($[59] !== t11 || $[60] !== t12 || $[61] !== t13 || $[62] !== t14 || $[63] !== t15) {
    t16 = <div className={t11}>{t12}{t13}{t14}{t15}</div>;
    $[59] = t11;
    $[60] = t12;
    $[61] = t13;
    $[62] = t14;
    $[63] = t15;
    $[64] = t16;
  } else {
    t16 = $[64];
  }
  let t17;
  if ($[65] !== ImageSliderContainer || $[66] !== t16) {
    t17 = <ImageSliderContainer noMobilePadding={true}>{t16}</ImageSliderContainer>;
    $[65] = ImageSliderContainer;
    $[66] = t16;
    $[67] = t17;
  } else {
    t17 = $[67];
  }
  return t17;
};
ImageSliderStandard.propTypes = {
  arrowPosition: PropTypes.oneOf(['standard', 'inset']),
  config: PropTypes.shape({
    children: PropTypes.node,
    description: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    imageArray: PropTypes.any,
    imgArray: PropTypes.array,
    logo: PropTypes.string,
    navType: PropTypes.string,
    sliderConfig: PropTypes.shape({
      afterSlideFn: PropTypes.func,
      beforeSlideFn: PropTypes.func,
      description: PropTypes.string,
      deviceOverride: PropTypes.bool,
      imageHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      imageWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      infinite: PropTypes.bool,
      logo: PropTypes.string,
      navType: PropTypes.string,
      title: PropTypes.string,
      visibleSlides: PropTypes.number,
      sliderIndex: PropTypes.number,
      fullHeight: PropTypes.bool
    }),
    title: PropTypes.string,
    variation: PropTypes.shape({
      value: PropTypes.string
    }),
    visibleSlides: PropTypes.number
  }),
  fabricGridControls: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  isMobileMaterialSwatches: PropTypes.bool,
  disableSliding: PropTypes.bool,
  variant: PropTypes.oneOf(['material-swatches-sidebar', 'reviews-list'])
};
const ImageSliderStandardUI = props => {
  const $ = _c(7);
  if (props?.config?.elementAttribute?.id) {
    const t0 = props?.config?.elementAttribute?.id;
    let t1;
    if ($[0] !== props) {
      t1 = <ImageSliderStandard {...props} />;
      $[0] = props;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
      t2 = <div id={t0}>{t1}</div>;
      $[2] = t0;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t0;
  if ($[5] !== props) {
    t0 = <ImageSliderStandard {...props} />;
    $[5] = props;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};
ImageSliderStandardUI.propTypes = {
  arrowPosition: PropTypes.oneOf(['standard', 'inset']),
  config: PropTypes.shape({
    children: PropTypes.node,
    description: PropTypes.string,
    elementAttribute: PropTypes.shape({
      id: PropTypes.number
    }),
    // eslint-disable-next-line react/forbid-prop-types
    imageArray: PropTypes.any,
    imgArray: PropTypes.array,
    logo: PropTypes.string,
    navType: PropTypes.string,
    sliderConfig: PropTypes.shape({
      afterSlideFn: PropTypes.func,
      beforeSlideFn: PropTypes.func,
      description: PropTypes.string,
      deviceOverride: PropTypes.bool,
      imageHeight: PropTypes.number,
      imageWidth: PropTypes.number,
      infinite: PropTypes.bool,
      logo: PropTypes.string,
      navType: PropTypes.string,
      title: PropTypes.string,
      visibleSlides: PropTypes.number,
      fullHeight: PropTypes.bool
    }),
    title: PropTypes.string,
    variation: PropTypes.shape({
      value: PropTypes.string
    }),
    visibleSlides: PropTypes.number
  }),
  fabricGridControls: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  isMobileMaterialSwatches: PropTypes.bool,
  disableSliding: PropTypes.bool,
  variant: PropTypes.oneOf(['material-swatches-sidebar', 'reviews-list'])
};
export default ImageSliderStandardUI;